import React, { useState } from 'react';
import { XIcon, SparklesIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white py-3 px-4 relative overflow-hidden" data-id="element-65">
      {/* Animated background effect */}
      <div className="absolute inset-0 bg-white/5" aria-hidden="true" data-id="element-66"></div>
      <div className="container mx-auto relative z-10" data-id="element-67">
        <div className="flex items-center justify-center gap-3" data-id="element-68">
          <SparklesIcon className="flex-shrink-0" size={18} aria-hidden="true" data-id="element-69" />
          {/* Mobile text - shorter but clear */}
          <p className="sm:hidden text-sm font-medium text-center leading-snug" data-id="element-70">
            <span className="font-bold" data-id="element-71">New!</span> We now offer IVF Telephone Monitoring through our partner clinics.
          </p>
          {/* Desktop text - full message */}
          <p className="hidden sm:block text-sm md:text-base font-medium text-center" data-id="element-72">
            <span className="font-bold" data-id="element-73">New!</span> We now offer IVF Telephone Monitoring through our partner clinics.
          </p>
          <button onClick={() => setIsVisible(false)} className="flex-shrink-0 p-1 hover:bg-white/10 rounded-full transition-colors ml-2" aria-label="Close announcement" data-id="element-74">
            <XIcon size={18} data-id="element-75" />
          </button>
        </div>
      </div>
    </div>;
}